import "core-js/modules/es.array.reduce.js";
import WorksApi from '@/frontend/api/works';
import WorksFilterComponent from '@/frontend/components/WorksFilterComponent';
import EmptyResultComponent from '@/frontend/components/EmptyResultComponent';
import SpinnerComponent from '@/frontend/components/SpinnerComponent';
import { ElLoading } from 'element-plus';
import setMetas from '@/frontend/functions/setMetas';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
export default {
  name: "WorksPage",
  components: {
    WorksFilterComponent,
    EmptyResultComponent,
    WorkCardComponent,
    SpinnerComponent
  },

  data() {
    return {
      Works: [],
      PaginationLinks: {},
      PaginationMeta: {
        currentPage: 1,
        pageCount: 1
      },
      search: '',
      workRequestParams: {},
      worksLoader: {
        load: false,
        title: 'Пусто',
        description: 'Нет работ, соответствующих заданным параметрам отбора'
      },
      scroll: {
        x: 0,
        y: 0
      }
    };
  },

  watch: {
    search() {
      this.PaginationMeta.currentPage = 1;
      this.workRequestParams.page = 1;
      this.requestWorks();
    },

    '$route.query': {
      handler(params) {
        if (!params.page) return;
        this.PaginationMeta.currentPage = params.page;
        if (this.Works.length) this.requestWorks();
      },

      immediate: true
    }
  },
  methods: {
    requestWorks(reload = true) {
      this.workRequestParams['filter[or][][workName][like]'] = this.search;
      this.workRequestParams['filter[or][][authorName][like]'] = this.search;
      this.workRequestParams.page = this.PaginationMeta.currentPage;
      WorksApi.get(this.workRequestParams).then(response => {
        response.items.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        if (reload) this.Works = response.items;else this.Works = this.Works.concat(response.items);
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
      }).finally(() => this.worksLoader.load = true);
    },

    changePage() {
      let number;
      if (!this.worksLoader.load) return;
      number = ++this.PaginationMeta.currentPage;
      if (number < 1 || this.PaginationMeta.pageCount && number > this.PaginationMeta.pageCount) return;
      this.worksLoader.load = false;
      this.PaginationMeta.currentPage = number;
      this.workRequestParams.page = number;
      this.requestWorks(false);
    },

    filterWorks(authorIds = [], years = []) {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      this.worksLoader.load = false;
      this.workRequestParams['filter[year][in]'] = years;
      this.workRequestParams['filter[authorId][in]'] = authorIds;
      WorksApi.get(this.workRequestParams).then(response => {
        response.items.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.Works = response.items;
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
        this.worksLoader.load = true;
        loader.close();
      });
    },

    handleScroll() {
      if (window.scrollY + window.innerHeight >= this.$refs.catalog.offsetTop + this.$refs.catalog.clientHeight) {
        this.Works.length && this.changePage();
      }
    }

  },

  created() {
    setMetas('works');
    this.workRequestParams = {
      fields: ['id', 'name', 'thumbWithPath', 'status_id', 'characteristics', 'author.id', 'author.name'].join(','),
      expand: ['author'].join(','),
      'per-page': 21
    };
    this.requestWorks();
  },

  activated() {
    window.scroll(this.scroll.x, this.scroll.y);
    window.addEventListener('scroll', this.handleScroll);
  },

  deactivated() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  beforeRouteLeave() {
    this.scroll.x = window.scrollX;
    this.scroll.y = window.scrollY;
  }

};